import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export const state = {
  products: {},
  hasMore: true,
  loading: false,
  lastVisible: '',
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
